import type { Ref, TextareaHTMLAttributes } from 'react';
import { forwardRef } from 'react';

import type {
  InputBorderColorVariant,
  InputColorVariant,
} from '@/components/Input';
import { generateDataTestId } from '@/lib/tests';

import * as S from './TextArea.styles';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  borderColorVariant?: InputBorderColorVariant;
  colorVariant?: InputColorVariant;
  hasError?: boolean;
}

export const TextArea = forwardRef(
  (
    { disabled = false, hasError = false, onChange, ...props }: TextAreaProps,
    ref: Ref<HTMLTextAreaElement>,
  ) => {
    return (
      <S.Wrapper
        {...generateDataTestId('input', 'wrapper')}
        disabled={disabled}
      >
        <S.TextArea
          ref={ref}
          disabled={disabled}
          onChange={(e) => {
            if (!disabled && onChange) onChange(e);
          }}
          {...props}
          error={hasError}
        />
      </S.Wrapper>
    );
  },
);

TextArea.displayName = 'TextArea';
